import { GroupTenantsList } from '@/backoffice/features/groups/components/group-tabs/group-tenants-list';
import { SubgroupsList } from '@/shared/features/groups/components/subgroups-list/subgroups-list';
import { GroupRolesList } from '@/shared/features/rbac/components/roles-list/variants/group-roles-list/group-roles-list';
import { GroupUsersList } from '@/shared/features/rbac/components/users-list/variants/group-users-list/group-users-list';
import { TCustomRouteObject } from '@/shared/types/router.types';

export const groupInnerRoutes: TCustomRouteObject[] = [
  {
    path: 'tenants',
    Component: () => <GroupTenantsList />,
    handle: { crumb: { label: 'tenants', localized: true } },
  },
  {
    path: 'users',
    Component: () => <GroupUsersList />,
    handle: { crumb: { label: 'users', localized: true } },
  },
  {
    path: 'roles',
    Component: () => <GroupRolesList />,
    handle: { crumb: { label: 'roles', localized: true } },
  },
  {
    path: 'subgroups',
    Component: () => <SubgroupsList />,
    handle: { crumb: { label: 'subgroups', localized: true } },
  },
];
